export default "__VITE_ASSET__3a28f91c__"